const pageContentCache = new Map<string, string>();

export default class SizeAndFit extends HTMLElement {
  private content: HTMLElement | null = null;

  connectedCallback(): void {
    this.content = this.querySelector('[data-size-and-fit-ref="content"]');

    if (!this.dataset.pageUrl || !this.content) {
      return;
    }

    this.fetchPageContent(this.dataset.pageUrl);
  }

  private async fetchPageContent(pageUrl: string): Promise<void> {
    try {
      const cachedContent = pageContentCache.get(pageUrl);

      if (cachedContent) {
        this.content!.innerHTML = cachedContent;
        return;
      }

      const response = await fetch(pageUrl);

      if (!response.ok) {
        throw new Error(`Failed to fetch size guide page (${response.status})`);
      }

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const contents = parsed.querySelectorAll('[data-ajax-content]');

      if (!contents.length || !this.content) {
        return;
      }

      let formattedContent = document.createElement('div');
      contents.forEach((content) => {
        formattedContent.appendChild(content.cloneNode(true));
      });

      pageContentCache.set(pageUrl, formattedContent.innerHTML);
      this.content.innerHTML = formattedContent.innerHTML;
    } catch (error) {
      console.error(error);
    }
  }
}

customElements.define('size-and-fit', SizeAndFit);
